import { render, staticRenderFns } from "./goodCard.vue?vue&type=template&id=ab99763e&scoped=true&"
import script from "./goodCard.vue?vue&type=script&lang=js&"
export * from "./goodCard.vue?vue&type=script&lang=js&"
import style0 from "./goodCard.vue?vue&type=style&index=0&id=ab99763e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab99763e",
  null
  
)

export default component.exports